import { NavLink } from "@remix-run/react";
import { useState } from "react";

import Logo from "~/components/logo/Logo";
import { CURRENT_OFFER } from "~/config/constants";
import { useBooking } from "~/context/BookingContext";
import { useLocalizedPath } from "~/helpers/navigationHelper";
import common from "~/i18n/common";
import { useT } from "~/i18n/useT";

import "./Header.scss";
import LanguageDropdown from "./LanguageDropdown";
import MobileMenu from "./MobileMenu";

export default function Header() {
  const t = useT(common);
  const localize = useLocalizedPath();
  const booking = useBooking();
  const [menuOpen, setMenuOpen] = useState(false);

  const links = [
    { to: "/courses", label: t.nav.courses },
    { to: "/pricing", label: t.nav.pricing, offer: CURRENT_OFFER },
    { to: "/about", label: t.nav.about },
    { to: "/contact", label: t.nav.contact },
  ];

  return (
    <>
      <header className="ss-header">
        <div className="ss-header__inner">
          <Logo />

          <nav className="ss-header__nav" aria-label={t.brand.name}>
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={localize(link.to)}
                className={({ isActive }) =>
                  `ss-header__link${isActive ? " is-active" : ""}`
                }
              >
                {link.label}
                {/* dir="ltr" keeps "-30%" from reordering to "30%-" in Arabic. */}
                {link.offer ? (
                  <span className="ss-header__offer" dir="ltr">
                    -{link.offer}%
                  </span>
                ) : null}
              </NavLink>
            ))}
          </nav>

          <div className="ss-header__actions">
            <LanguageDropdown />

            <button
              type="button"
              className="ss-btn ss-btn--primary ss-header__cta"
              onClick={() => booking.open()}
            >
              {t.nav.bookCall}
            </button>

            <button
              type="button"
              className="ss-header__burger"
              aria-label={t.nav.openMenu}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen(true)}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </header>

      <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}
